const messaging = () => ({
  isDeviceRegisteredForRemoteMessages: false,
  requestPermission: async () => 0,
  registerDeviceForRemoteMessages: async () => {},
  getAPNSToken: async () => null,
  getToken: async () => null,
  onTokenRefresh: () => () => {},
  onMessage: () => () => {},
  onNotificationOpenedApp: () => () => {},
  getInitialNotification: async () => null,
  setBackgroundMessageHandler: () => {}
});

messaging.AuthorizationStatus = { AUTHORIZED: 1, PROVISIONAL: 2 };

export default messaging;
